export type ChatConversation = {
  type: "user" | "roleBroadcast";
  code: number;
  groupId: number | null;
  name: string;
  online: boolean;
  lastActive: string | null;
  lastMessage: string;
  lastMessageDate: string;
  unreadCount: number;
  recipientCount: number;
  readCount: number;
};

export type ChatReaction = {
  CODUSU: number;
  EMOCHA: string;
  NOMUSU?: string;
};

export type ChatMessage = {
  CODCHA: number;
  GRPCHA: number;
  REMCHA: number;
  DESCHA: number;
  ROLCHA: number | null;
  MSGCHA: string;
  EDICHA: string | null;
  FECCHA: string;
  DELCHA: string | null;
  LEICHA: string | null;
  BORCHA: string | null;
  REMNAME?: string;
  DESNAME?: string;
  ROLNAME?: string;
  reactions?: ChatReaction[];
};

export const quickReactions = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

// Shown when the user taps the "+" on the quick-reaction row, for anything
// not covered by the curated quick list above.
export const extendedReactions = [
  "😀", "😁", "😅", "😊", "🙂", "😉", "😍", "😘", "😜", "🤔",
  "😎", "🥳", "😴", "🤯", "🥺", "😭", "😡", "🤬", "😱", "🤗",
  "🤝", "👏", "🙌", "💪", "🤞", "✌️", "👋", "👀", "🔥", "✨",
  "🎉", "💯", "⭐", "💔", "💕", "😇", "🤓", "😏", "🙄", "😬",
  "🤤", "🤐", "🥶", "🤒", "🤮", "💀",
];

// "role": a freshly-picked role, not sent yet (no groupId, nothing to poll).
// "roleBroadcast": a role send that already happened (has a groupId) — viewed
// as a read-receipt list, not a back-and-forth thread; sending again from
// here starts a brand new broadcast (a fresh GRPCHA), since fan-out has no
// concept of appending to a past broadcast.
export type ActiveChatTarget = {
  type: "user" | "role" | "roleBroadcast";
  code: number;
  groupId: number | null;
  name: string;
};
